export default __webpack_public_path__ + "static/media/cartaoGoldAthleticoPrVertical.1300cc87.svg";